import { useState, useEffect } from 'react';
import { Flame, Clock } from 'lucide-react';

// Sunday June 28, 2026, midnight US EST = June 29 05:00 UTC
const DEADLINE = new Date('2026-06-29T05:00:00Z');

function pad(n: number) {
  return String(n).padStart(2, '0');
}

export function FoundingOfferCountdown() {
  const [diff, setDiff] = useState(Math.max(0, DEADLINE.getTime() - Date.now()));

  useEffect(() => {
    const id = setInterval(() => setDiff(Math.max(0, DEADLINE.getTime() - Date.now())), 1000);
    return () => clearInterval(id);
  }, []);

  const expired = diff === 0;

  const totalSecs = Math.floor(diff / 1000);
  const d = Math.floor(totalSecs / 86400);
  const h = Math.floor((totalSecs % 86400) / 3600);
  const m = Math.floor((totalSecs % 3600) / 60);
  const s = totalSecs % 60;

  if (expired) return null;

  const units = d > 0
    ? [{ v: d, l: 'Days' }, { v: h, l: 'Hours' }, { v: m, l: 'Mins' }, { v: s, l: 'Secs' }]
    : [{ v: h, l: 'Hours' }, { v: m, l: 'Mins' }, { v: s, l: 'Secs' }];

  return (
    <div className="bg-gradient-to-r from-orange-500 to-amber-500 text-white">
      <div className="max-w-5xl mx-auto px-6 py-3 flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6">
        <div className="flex items-center gap-2 flex-shrink-0">
          <Flame className="w-4 h-4 text-white/90" />
          <span className="font-bold text-sm">Founding Offer Ends Sunday</span>
          <span className="hidden sm:inline text-white/70 text-sm">—</span>
          <span className="hidden sm:inline text-sm text-white/90">Early-access pricing + free onboarding on yearly plans</span>
        </div>

        <div className="flex items-center gap-2">
          <Clock className="w-3.5 h-3.5 text-white/70 flex-shrink-0" />
          <div className="flex items-center gap-1.5">
            {units.map(({ v, l }, i) => (
              <div key={i} className="flex items-center gap-1.5">
                {i > 0 && <span className="text-white/50 font-mono text-base leading-none">:</span>}
                <div className="flex flex-col items-center">
                  <span className="font-mono font-bold text-lg tabular-nums leading-none">{pad(v)}</span>
                  <span className="text-[9px] text-white/70 uppercase tracking-wide">{l}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
